'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var tslib = require('tslib');
var magicMessages = require('@gig/magic-messages');

function getMailCheckConfig() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            return [2 /*return*/, magicCommon.configQuery('mailCheck')];
        });
    });
}
function getPersonalIdConfig() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, magicCommon.configQuery('signup.personalId')];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function getIbanConfig() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, magicCommon.configQuery('signup.iban')];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function getPasswordValidationConditions() {
    var _a;
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, magicCommon.configQuery('signup.passwordValidationConditions.DEFAULT')];
                case 1: return [2 /*return*/, ((_a = (_b.sent())) !== null && _a !== void 0 ? _a : [])];
            }
        });
    });
}
function getPasswordMaxLength() {
    var _a;
    return tslib.__awaiter(this, void 0, void 0, function () {
        var defaultLength, conditions, max;
        return tslib.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    defaultLength = 8;
                    return [4 /*yield*/, getPasswordValidationConditions()];
                case 1:
                    conditions = (_b.sent()).filter(function (condition) { return condition.name; });
                    max = conditions.find(function (condition) { return condition.name === magicCommon.RuleKey.maxLength; });
                    if (max) {
                        return [2 /*return*/, (_a = +max.value) !== null && _a !== void 0 ? _a : defaultLength];
                    }
                    return [2 /*return*/, defaultLength];
            }
        });
    });
}
function getMinimumAge() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var minimumAge, currentIpCountry;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, magicCommon.configQuery('signup.legalAge')];
                case 1:
                    minimumAge = _a.sent();
                    return [4 /*yield*/, window.queryBus.query(magicMessages.IP_COUNTRY_QUERY)];
                case 2:
                    currentIpCountry = _a.sent();
                    return [2 /*return*/, magicCommon.objectValueOrDefault(minimumAge, currentIpCountry)];
            }
        });
    });
}
function getMaximumAge() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var maximumAge, currentIpCountry;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, magicCommon.configQuery('signup.maximumAge')];
                case 1:
                    maximumAge = _a.sent();
                    return [4 /*yield*/, window.queryBus.query(magicMessages.IP_COUNTRY_QUERY)];
                case 2:
                    currentIpCountry = _a.sent();
                    return [2 /*return*/, magicCommon.objectValueOrDefault(maximumAge, currentIpCountry)];
            }
        });
    });
}
function getPhoneConfig() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var wandConfig, prefixes;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, magicCommon.configQuery('signup.phoneNumberValidator')];
                case 1:
                    wandConfig = _a.sent();
                    return [4 /*yield*/, magicCommon.configQuery('countries.customPrefixes')];
                case 2:
                    prefixes = _a.sent();
                    return [2 /*return*/, {
                            numberValidator: wandConfig,
                            visibleForCountry: {
                                DEFAULT: true,
                            },
                            customPrefixes: prefixes,
                        }];
            }
        });
    });
}
function getSecurityQuestionsConfig() {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var config, currentIpCountry;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, magicCommon.configQuery('signup.securityQuestions')];
                case 1:
                    config = _a.sent();
                    if (!config) {
                        return [2 /*return*/, { enabled: false, maxLength: 0 }];
                    }
                    return [4 /*yield*/, window.queryBus.query(magicMessages.IP_COUNTRY_QUERY)];
                case 2:
                    currentIpCountry = _a.sent();
                    return [2 /*return*/, {
                            enabled: magicCommon.objectValueOrDefault(config.enabled, currentIpCountry),
                            maxLength: magicCommon.objectValueOrDefault(config.maxLength, currentIpCountry),
                        }];
            }
        });
    });
}

exports.getIbanConfig = getIbanConfig;
exports.getMailCheckConfig = getMailCheckConfig;
exports.getMaximumAge = getMaximumAge;
exports.getMinimumAge = getMinimumAge;
exports.getPasswordMaxLength = getPasswordMaxLength;
exports.getPasswordValidationConditions = getPasswordValidationConditions;
exports.getPersonalIdConfig = getPersonalIdConfig;
exports.getPhoneConfig = getPhoneConfig;
exports.getSecurityQuestionsConfig = getSecurityQuestionsConfig;
